import { gql } from 'graphql-request'

export const GetSpeciStationDataGql = gql`
  query speciStationDetails($recordNumber: String!) {
    stationDetailsForSpeci(request: { stationRecordNumber: $recordNumber }) {
      brand
      tradingName
      currentSeasonContracts {
        contractName
      }
    }
  }
`
